/**
 * Links from the console into the driver-facing cab app (ClientApps/wzcab), which owns /cab/:token
 * and /clip.
 *
 * Kept behind one helper because the two apps may or may not share an origin: served together
 * behind path routing these are plain same-origin URLs, but a split deployment points
 * REACT_APP_CAB_APP_ROOT_URL at the cab app's host and every QR code and Watch link follows. The
 * QR especially must be absolute — it gets printed and taped inside a truck.
 */
const CAB_APP_ROOT = (process.env.REACT_APP_CAB_APP_ROOT_URL ?? "").replace(/\/+$/, "");

function cabAppUrl(path: string): string {
    return `${CAB_APP_ROOT || window.location.origin}${path}`;
}

/**
 * The in-cab screen for a device's cab-card token — what the printed QR encodes.
 *
 * Token at the root, so a laminated card reads cab.omnisightusa.com/<token>. The cab app still
 * honours the older /cab/<token> form for cards already hanging in trucks.
 */
export const cabCardUrl = (token: string) => cabAppUrl(`/${token}`);

/** The anonymous clip viewer an event's Watch link opens. */
export const clipUrl = (clipAccessToken: string) => cabAppUrl(`/clip?token=${clipAccessToken}`);
